<template>
    <div class="header">
        <i class="el-icon-menu menu-icon" @click="leftbarStatus"></i>
        <profile></profile>
    </div>
</template>
<script>

import Token from '@/utils/token'
import Profile from '@/components/header/components/profile.vue'

export default {
  name: 'AdminHomeTop',
  props: ['isCollapse'],
  components: {Profile},
  data () {
    return {
      isLogin: false,
    }
  },
  mounted () {
    if (Token.getToken()) {
      this.isLogin = true
    }
  },
  methods: {
    leftbarStatus () {
      this.$emit('sideBarStatus', !this.isCollapse)
    },
  }
}
</script>
<style lang="stylus" scoped>
.header
  width: 100%
  height: 60px
  background-color: #9CA3AF
  display: flex
  justify-content: space-between
  .menu-icon
    line-height: 60px
    font-size: 30px
    cursor: pointer
    padding-left: 20px
</style>
